module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner"
  }, [_c('div', {
    staticClass: "headBar"
  }, [_vm._v("新建解读")]), _vm._v(" "), _c('div', {
    staticClass: "pgbody",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('el-scrollbar', {
    ref: "scroller",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "tabContent"
  }, [_c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("关联申报")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-select', {
    staticClass: "inpText",
    attrs: {
      "placeholder": "选择申报"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("解读标题")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("发文机构")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("缩略图")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("内容类型")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-radio-group', {
    staticClass: "radioGp",
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("文字解读")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("图片解读")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("视频解读")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [(_vm.radio == 1) ? _c('span', [_vm._v("文字解读")]) : _vm._e(), _vm._v(" "), (_vm.radio == 2) ? _c('span', [_vm._v("图片解读")]) : _vm._e(), _vm._v(" "), (_vm.radio == 3) ? _c('span', [_vm._v("视频解读")]) : _vm._e()]), _vm._v(" "), (_vm.radio == 1) ? _c('div', {
    staticClass: "bContent"
  }, [_c('editor', {
    attrs: {
      "id": "editor_id",
      "height": "500px",
      "width": "100%",
      "content": _vm.editorText,
      "pluginsPath": "/static/kindeditor/plugins/",
      "loadStyleMode": false
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.radio == 2) ? _c('div', {
    staticClass: "bContent"
  }, [_c('imgUpload')], 1) : _vm._e(), _vm._v(" "), (_vm.radio == 3) ? _c('div', {
    staticClass: "bContent"
  }, [_c('mvUpload')], 1) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "pagefoot"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v("立即发布")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v("发布并新建解读")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": "",
      "size": "small"
    }
  }, [_vm._v("存为草稿")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": "",
      "size": "small"
    }
  }, [_vm._v("取消")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-6891397a"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/declare/unscramble.vue
// module id = 1513
// module chunks = 1